import { render, staticRenderFns } from "./footer2.vue?vue&type=template&id=481b8a5e&scoped=true"
import script from "./footer2.vue?vue&type=script&lang=js"
export * from "./footer2.vue?vue&type=script&lang=js"
import style0 from "./footer2.vue?vue&type=style&index=0&id=481b8a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b8a5e",
  null
  
)

export default component.exports